import { useEffect, useState } from "react";
import { createChainJob, getChainJob } from "../../data/chainJob/chainJob.repository";
import { ChainJobRequest, GetChainJobRequest, GetChainJobResponse } from "../../data/chainJob/chainJob.shemas";
import { getCompanyMaster } from "../../data/common/company.repository";
import { CompanyMaster } from "../../models/companymaster/CompanyMaster";
import { parseJwt } from "../../modules/common";

export default function ChainJobConfigViewModel() {
    const [citizenId, setCitizenId] = useState<string>();
    const [isShowModal, setIsShowModal] = useState<boolean>(false)
    const [companyMaster, setCompanyMaster] = useState<CompanyMaster[]>()
    const [chainJobParams, setChainJobParams] = useState<GetChainJobRequest>({
        chainJobId: '',
        chainJobName: '',
        companyCode: ''
    })
    const [chainJobResponse, setChainJobResponse] = useState<GetChainJobResponse[]>()

    useEffect(() => {
        const token = localStorage.getItem('LG_APPLICATION');

        var jwt = parseJwt(token!)
        var extra = JSON.parse(jwt.extra)
        setCitizenId(extra.citizen_id)

        fetchCompanyMaster();

        fetchChainJob();
    }, [])

    const handleActionModal = (action: boolean) => {
        setIsShowModal(action);
    }

    const handleCreateChainJob = async (body: ChainJobRequest) => {
        body.CreatedBy = citizenId;

        const response = await createChainJob(body);

        if (response === 'success') {

        }
    }

    const fetchCompanyMaster = async () => {
        const response = await getCompanyMaster();

        if (response) {
            setCompanyMaster(response.result_list)
        }
    }

    const fetchChainJob = async () => {
        const resposne = await getChainJob(chainJobParams);

        if (resposne) {
            console.log(resposne)
            setChainJobResponse(resposne);
        }
    }

    const handleChangeSearchHelp = (key: keyof GetChainJobRequest, value: GetChainJobRequest[keyof GetChainJobRequest]) => {
        setChainJobParams(prevState => {
            return {
                ...prevState,
                [key]: value
            };
        });
    }


    return {
        isShowModal,
        companyMaster,
        chainJobResponse,

        fetchChainJob,
        handleActionModal,
        handleCreateChainJob,
        handleChangeSearchHelp
    }
}